import { useState, useEffect, useCallback } from 'react';
import { stateProvinceService } from 'api/services/stateProvinceService';
import type { StateProvince } from 'api/types';

/** Fetch states/provinces for a given country. Refetches when countryId changes. */
export const useStateProvinces = (countryId?: string | null) => {
  const [data, setData] = useState<StateProvince[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchStates = useCallback(async () => {
    if (!countryId) { setData([]); return; }
    setLoading(true);
    setError(null);
    try {
      const response = await stateProvinceService.getByCountry(countryId);
      setData(response.data);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, [countryId]);

  useEffect(() => { fetchStates(); }, [fetchStates]);

  return { data, loading, error, refetch: fetchStates };
};
